import { type ApolloError, useLazyQuery } from '@apollo/client';
import * as Sentry from '@sentry/react';

import LearnerProfileLearningGoalQuery from 'bundles/onboarding-common/queries/LearnerProfileLearningGoal.graphql';
import type {
  LearnerProfileLearningGoalQueryQuery,
  LearnerProfileLearningGoalQueryQueryVariables,
} from 'bundles/onboarding-common/queries/__generated__/LearnerProfileLearningGoal';
import { formatLearningGoalFromLearnerProfile } from 'bundles/onboarding-common/utils/savedQuestionDataUtils';

const useFetchLearningGoalData = () => {
  const [fetchData] = useLazyQuery<LearnerProfileLearningGoalQueryQuery, LearnerProfileLearningGoalQueryQueryVariables>(
    LearnerProfileLearningGoalQuery,
    {
      context: { clientName: 'gatewayGql' },
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
    }
  );

  const handleError = (error: ApolloError | Error) => {
    Sentry.captureMessage('Error fetching learning goal data', {
      extra: {
        error: error.message,
      },
    });
  };

  const fetchLearningGoalData = async () => {
    try {
      const { data, error } = await fetchData();

      if (error) {
        handleError(error);
        return null;
      }

      return formatLearningGoalFromLearnerProfile(data);
    } catch (error) {
      handleError(error);

      return null;
    }
  };

  return {
    fetchLearningGoalData,
  };
};

export default useFetchLearningGoalData;
